import { ReactNode } from "react";
import "./contacts-item.sass";

type Props = {
  title: string;
  children: ReactNode;
  className?: string;
};

const ContactsItem = ({ children, className, title }: Props) => {
  return (
    <div className={`contacts-item${className ? ` ${className}` : ""}`}>
      <div className="contacts-item__title">{title}</div>

      <div className="contacts-item__content">{children}</div>
    </div>
  );
};

export default ContactsItem;
